import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  formContent: {
    height: '100%',
  },
  manualRedactPopperContent: {
    height: '100%',
    width: 'auto',
    display: 'flex',
    padding: '15px',
    paddingBottom: '10px',
    paddingRight: '20px',
    backgroundColor: 'white',
    boxShadow:
      '0 2px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 4px 0 rgba(0, 0, 0, 0.12), 0 1px 5px 0 rgba(0, 0, 0, 0.2)',
  },
  unredactButton: {
    color: '#E81D63 !important',
    '&:hover': {
      background: 'rgba(233, 30, 99, 0.05) !important',
    },
  },
}));
